import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    objAdd:{  //地址簿保存站
    },
    num:0,  //菜单对应下标
    url:'/indent'  //会员中心初始导航
  },
  mutations: {
    setadd(state,v){
      state.objAdd=v
    },
    setnum(state,v){
      state.num=v
    },
    seturl(state,v){
      state.url=v
    }
  },
  getters:{
  },
  actions: {
    getAdd(){
      console.log('調用')
    }
  },
  modules: {
  }
})



// WEBPACK FOOTER //
// ./src/store.js